import validationRules from "../validationRules";
validationRules.register("function", function (record, fieldMetadataMap, fieldName, t) {
    var value = record[fieldName];
    if (!value) {
        return true;
    }
    var dataHasError = value.filter(function (item) {
        return item.isValid === false;
    });
    if (dataHasError.length > 0)
        return "has error.";
    else
        return true;
});
